exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.planner-role-banner-button {\n  display: none;\n}\n", ""]);

